import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FireAnalyticsService } from '@service/fire-analytics.service';

@Component({
  selector: 'app-risk-mismatch',
  templateUrl: './risk-mismatch.component.html',
  styles: [
  ]
})
export class RiskMismatchComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<RiskMismatchComponent>,
    private analytics: FireAnalyticsService
  ) { }

  ngOnInit(): void {
  }

  closeDialog(isUpdate: boolean){
    if(isUpdate){
      this.analytics.logEvents('Risk Mismatch Accept')
    }
    this.dialogRef.close(isUpdate)
  }

}
